/// <reference types="@angular/localize" />
import { enableProdMode, importProvidersFrom } from '@angular/core';
import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { provideAnimations } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app/app-routing.module';
import { DatePipe } from '@angular/common';
import { CustomUrlSerializer } from './app/custom-url-serializer';
import { UrlSerializer, provideRouter } from '@angular/router';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { GlobalCache } from './app/cache-utils.service';
import { SafeArea } from '@capacitor-community/safe-area';
import { Capacitor } from '@capacitor/core';
import { provideMobileTooltipDisable } from './app/services/tooltip/tooltip-mobile-disable';
import { shouldEnableServiceWorker } from './app/utils/service-worker-registration';

document.body.setAttribute('data-platform', Capacitor.getPlatform());

function isServiceWorkerEnabledForThisResponse(): boolean {
  const navigationEntry = performance.getEntriesByType(
    'navigation'
  )[0] as PerformanceNavigationTiming | undefined;

  return shouldEnableServiceWorker(
    environment.environment.production,
    navigationEntry?.serverTiming ?? []
  );
}

SafeArea.enable({
  config: {
    customColorsForSystemBars: true,
    statusBarColor: '#000000',
    statusBarContent: 'light',
    navigationBarColor: '#000000',
    navigationBarContent: 'light',
    offset: 0,
  },
});

if (environment.environment.production) {
  enableProdMode();
} else {
  console.log('Development mode');
  (window as any).debugCache = GlobalCache;
}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(
      AppRoutingModule,
      ReactiveFormsModule,
      FormsModule,
      BrowserModule,
      MatSnackBarModule,
      MatDialogModule,
      ServiceWorkerModule.register('ngsw-worker.js', {
        enabled: isServiceWorkerEnabledForThisResponse(),
      }),
      MatDatepickerModule,
      MatNativeDateModule,
      MatFormFieldModule
    ),
    { provide: UrlSerializer, useClass: CustomUrlSerializer },
    DatePipe,
    provideRouter([]),
    provideAnimations(),
    ...provideMobileTooltipDisable(),
  ],
}).catch((err) => console.log(err));
